import { Component } from '@angular/core';
import { ModalService } from '../../services/modal/modal.service';

@Component({
    selector: 'lsq-loading-modal',
    template: `
        <div class="modal-content">
            <div class="modal-header">
                <h1>
                    {{ title }}
                </h1>
                <lsq-circle-loader [showPadding]="false"></lsq-circle-loader>
            </div>
            <div class="modal-body">
                <p>
                    {{ subtitle }}
                </p>
            </div>
        </div>
    `,
    styles: [
        `
            .modal-content {
                padding-bottom: 1.5rem;
                .modal-header {
                    padding-right: 15rem;
                }
                lsq-circle-loader {
                    position: absolute;
                    top: 3rem;
                    right: 3rem;
                }
            }
        `
    ]
})
export class LsqLoadingModalComponent {
    public title: string;
    public subtitle: string;

    constructor(public modalService: ModalService) {}

    public ngOnInit(): void {
        const modalData = this.modalService.modal.data;
        if (modalData) {
            this.title = modalData.title;
            this.subtitle = modalData.subtitle;
        }
    }
}
